import React, {useMemo} from 'react'

export interface CopilotSettings {
  copilotAccessAllowed: boolean
  copilotSpacesEnabled: boolean
}

const CopilotSettingsContext = React.createContext<CopilotSettings>({
  copilotAccessAllowed: false,
  copilotSpacesEnabled: false,
})

interface CopilotSettingsProviderProps {
  copilotAccessAllowed?: boolean
  copilotSpacesEnabled?: boolean
}

export function CopilotSettingsProvider({
  children,
  copilotAccessAllowed = false,
  copilotSpacesEnabled = false,
}: React.PropsWithChildren<CopilotSettingsProviderProps>) {
  const value = useMemo(
    () => ({
      copilotAccessAllowed,
      copilotSpacesEnabled,
    }),
    [copilotAccessAllowed, copilotSpacesEnabled],
  )

  return <CopilotSettingsContext value={value}>{children}</CopilotSettingsContext>
}

export function useCopilotSettings() {
  return React.use(CopilotSettingsContext)
}
